// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"738":"3724182e","2461":"427fd216","2936":"624a0f16","4963":"42473467","5500":"3724182e","6276":"3724182e","9268":"3724182e"}[chunkId] + ".chunk.css";
};